/** German (`de`) catalog. */
export const catalogDe: Record<string, string> = {
  "quiz.account.menu_aria_label": "Account und Abmelden",
  "quiz.account.pending_summary": "Konto",
  "quiz.home.checking_session": "Anmeldestatus wird geprüft...",
  "quiz.home.cta_continue_my_quizzes": "Weiter zu Meine Quizze",
  "quiz.home.cta_create_quiz_primary": "Quiz erstellen",
  "quiz.home.cta_sign_in_organizer": "Anmelden",
  "quiz.home.footer_aux_aria_label": "Rechtliche Hinweise und Hilfe",
  "quiz.home.footer_legal": "© {year} Quiz. Alle Rechte vorbehalten.",
  "quiz.home.footer_link_contact": "Kontakt",
  "quiz.home.footer_link_help": "Hilfecenter",
  "quiz.home.footer_link_privacy": "Datenschutz",
  "quiz.home.footer_link_terms": "Nutzungsbedingungen",
  "quiz.home.header_sign_in": "Anmelden",
  "quiz.home.header_title": "Quiz",
  "quiz.home.hero_signed_in_generic": "Willkommen zurück",
  "quiz.home.hero_signed_in_named": "Hallo, {name}",
  "quiz.home.hero_signed_in_subtitle":
    "Erstellen und verwalten Sie Quizze für Ihre Schulungen.",
  "quiz.home.hero_subtitle":
    "Laden Sie Teilnehmende per E-Mail ein. Sie lernen und legen Tests ab.",
  "quiz.home.hero_title": "Schulungsquizze aus Ihren Dokumenten",
  "quiz.home.label_display_name": "Anzeigename",
  "quiz.home.label_user_id": "Benutzer-ID",
  "quiz.home.link_my_quizzes": "Meine Quizze",
  "quiz.home.link_view_existing_quizzes": "Bestehende Quizze anzeigen",
  "quiz.home.link_new_training_quiz":
    "Einrichtungs-Assistent starten (empfohlen)",
  "quiz.home.logout": "Abmelden",
  "quiz.home.logout_failed":
    "Abmeldung fehlgeschlagen. Bitte erneut versuchen.",
  "quiz.home.logout_pending": "Abmeldung wird ausgeführt...",
  "quiz.home.participant_guidance_body":
    "Teilnehmende erhalten per E-Mail einen Link zum Quiz.",
  "quiz.home.participant_guidance_summary": "So treten Teilnehmende bei",
  "quiz.home.role_organizers_bullet_1": "Schulungsmaterial hochladen.",
  "quiz.home.role_organizers_bullet_2":
    "Fragenpool erzeugen und Einladungen senden.",
  "quiz.home.role_organizers_title": "Organisatoren",
  "quiz.home.role_participants_bullet_1": "Link in der E-Mail verwenden.",
  "quiz.home.role_participants_bullet_2": "Quiz abschließen.",
  "quiz.home.role_participants_title": "Teilnehmende",
  "quiz.home.session_error": "Anmeldestatus konnte nicht geladen werden.",
  "quiz.home.signed_in_title": "Konto",
  "quiz.home.skip_to_main": "Zum Hauptinhalt springen",
  "quiz.my_quizzes.title": "Meine Quizze",
  "quiz.my_quizzes.loading": "Quizze werden geladen...",
  "quiz.my_quizzes.empty":
    "Noch keine Entwürfe. Unten anlegen, um Schulungsmaterial hinzuzufügen. Der Name kann vom ersten Datei-Upload übernommen werden; vor dem Veröffentlichen hier ändern.",
  "quiz.my_quizzes.feature_off":
    "Trainings-Quizze sind in dieser Umgebung nicht aktiviert.",
  "quiz.my_quizzes.sign_in_required": "Bitte anmelden, um Quizze zu verwalten.",
  "quiz.my_quizzes.load_failed": "Quizze konnten nicht geladen werden.",
  "quiz.my_quizzes.create_submit": "Quiz erstellen",
  "quiz.my_quizzes.create_failed":
    "Entwurf konnte nicht angelegt werden. Bitte erneut versuchen.",
  "quiz.my_quizzes.quiz_title_field": "Quiz-Titel",
  "quiz.my_quizzes.save_title": "Titel speichern",
  "quiz.my_quizzes.untitled_placeholder":
    "Ohne Titel — aus erster Datei oder manuell eingeben",
  "quiz.my_quizzes.title_save_failed":
    "Titel konnte nicht gespeichert werden. Bitte erneut versuchen.",
  "quiz.my_quizzes.quiz_status_draft": "Entwurf",
  "quiz.my_quizzes.quiz_status_published": "Veröffentlicht",
  "quiz.my_quizzes.quiz_status_other": "{status}",
  "quiz.my_quizzes.summary_with_pipeline": "{lifecycle} · {pipeline}",
  "quiz.my_quizzes.generation_phase_running": "Fragen werden generiert",
  "quiz.my_quizzes.generation_phase_failed": "Generierung fehlgeschlagen",
  "quiz.my_quizzes.generation_phase_queued": "Generierung eingereiht",
  "quiz.my_quizzes.generation_phase_other": "{phase}",
  "quiz.my_quizzes.created_line": "Erstellt {date}",
  "quiz.my_quizzes.loading_more": "Weitere werden geladen…",
  "quiz.detail.back_my_quizzes": "Zurück zu Meine Quizze",
  "quiz.detail.loading": "Quiz wird geladen...",
  "quiz.detail.sign_in_required": "Bitte anmelden, um dieses Quiz zu sehen.",
  "quiz.detail.not_found": "Quiz nicht gefunden oder kein Zugriff.",
  "quiz.detail.load_failed": "Quizdaten konnten nicht geladen werden.",
  "quiz.detail.recipients_failed":
    "Teilnehmerliste konnte nicht geladen werden.",
  "quiz.detail.created_line": "Erstellt {date}",
  "quiz.detail.quiz_id_line": "Quiz-ID: {quiz_id}",
  "quiz.detail.status_line": "Quiz-Status: {status}",
  "quiz.detail.title_edit_aria": "Quiz-Titel bearbeiten",
  "quiz.detail.title_edit_glyph": "\u270E",
  "quiz.detail.title_confirm_aria": "Titel speichern",
  "quiz.detail.title_confirm_glyph": "\u2713",
  "quiz.detail.title_cancel_aria": "Bearbeitung abbrechen",
  "quiz.detail.title_cancel_glyph": "\u2715",
  "quiz.detail.open_wizard_add_recipients":
    "Assistent öffnen, um Empfänger hinzuzufügen oder Einladungen zu senden",
  "quiz.detail.pool_heading": "Fragenpool",
  "quiz.detail.pool_summary":
    "Aktiv: {active}. Gespeichert gesamt: {total}. Inaktiv (keine Ziehung): {inactive}.",
  "quiz.detail.pool_empty": "Keine aktiven Fragen im Pool.",
  "quiz.detail.roster_heading": "Testteilnehmende",
  "quiz.detail.roster_empty": "Noch keine Zuordnungen.",
  "quiz.detail.roster_empty_hint_wizard":
    "Assistent öffnen, um Personen einzuladen.",
  "quiz.detail.col_email": "E-Mail",
  "quiz.detail.col_invitation": "Einladung",
  "quiz.detail.col_attempt": "Versuch",
  "quiz.detail.col_completed": "Abgeschlossen",
  "quiz.detail.col_invite": "Einladungslink",
  "quiz.detail.completed_dash": "-",
  "quiz.detail.invitation_sent": "Gesendet",
  "quiz.detail.invitation_not_sent": "Nicht gesendet",
  "quiz.detail.attempt_pass": "Bestanden",
  "quiz.detail.attempt_fail": "Nicht bestanden",
  "quiz.detail.attempt_in_progress": "Läuft",
  "quiz.detail.attempt_not_submitted": "Nicht gestartet",
  "quiz.detail.transcript_open_aria":
    "Übermitteltes Testprotokoll für {email} öffnen",
  "quiz.detail.transcript_title": "Testprotokoll",
  "quiz.detail.transcript_close": "Schließen",
  "quiz.detail.transcript_fullscreen": "Vollständige Seite",
  "quiz.detail.transcript_fullscreen_aria":
    "Dieses Protokoll auf einer eigenen Seite öffnen",
  "quiz.detail.transcript_back_to_quiz": "Zurück zum Test",
  "quiz.detail.transcript_loading": "Protokoll wird geladen…",
  "quiz.detail.transcript_error": "Protokoll konnte nicht geladen werden.",
  "quiz.detail.transcript_meta_line": "{email} · {date}",
  "quiz.detail.transcript_attempt_id": "Versuchs-ID: {id}",
  "quiz.detail.transcript_outcome_passed": "Ergebnis: Bestanden",
  "quiz.detail.transcript_outcome_failed": "Ergebnis: Nicht bestanden",
  "quiz.detail.transcript_score": "Punktzahl: {percent} %",
  "quiz.detail.transcript_selected_option":
    "Antwort der Teilnehmerin/des Teilnehmers: {text}",
  "quiz.detail.transcript_correct_option": "Richtige Antwort: {text}",
  "quiz.detail.transcript_no_selection": "(Keine Antwort erfasst)",
  "quiz.detail.transcript_mark_correct": "Als richtig gewertet",
  "quiz.detail.transcript_mark_incorrect": "Als falsch gewertet",
  "quiz.detail.transcript_signing_area_aria":
    "Unterschriftsbereich (Platz für handschriftliche Unterschriften beim Ausdruck)",
  "quiz.detail.get_invite_link": "Einladungslink holen",
  "quiz.detail.invite_link_confirm":
    "Neuen Einladungslink erzeugen? Frühere Links für diese Zuordnung funktionieren dann nicht mehr.",
  "quiz.detail.invite_link_copied":
    "Einladungslink in die Zwischenablage kopiert.",
  "quiz.detail.invite_link_manual_copy": "Diesen Einladungslink kopieren:",
  "quiz.detail.invite_link_failed":
    "Einladungslink konnte nicht geholt werden. Bitte erneut versuchen.",
  "quiz.detail.invite_link_no_origin":
    "Diese Umgebung kann keine Einladungslinks erzeugen (fehlende öffentliche Site-URL). QUIZ_INVITE_PUBLIC_ORIGIN beim Betrieb setzen.",
  "quiz.detail.choice_correct": "Richtig: {text}",
  "quiz.wizard.page_title": "Schulungsquiz einrichten",
  "quiz.wizard.back_my_quizzes": "Zu Meine Quizze",
  "quiz.wizard.progress": "Schritt {step} von {total}",
  "quiz.wizard.intro_lead":
    "Der Assistent führt Sie: Quizname, kommende Upload-Automatisierung, Teilnehmerliste, Versand.",
  "quiz.wizard.create_draft_button": "Entwurf anlegen und starten",
  "quiz.wizard.create_failed": "Entwurf konnte nicht angelegt werden.",
  "quiz.wizard.loading_quiz": "Quiz wird geladen...",
  "quiz.wizard.quiz_missing": "Konnte Quiz nicht laden.",
  "quiz.wizard.need_sign_in":
    "Bitte melden Sie sich über die Startseite erneut an.",
  "quiz.wizard.preview_note":
    "Generation, Pool und volle Publish-Checks folgen weiteren APIs. SES mit QUIZ_SES_MAIL_FROM. Schulungs-Uploads brauchen den Material-Bucket im Stack (QUIZ_MATERIAL_BUCKET).",
  "quiz.wizard.step_title_name": "Quiz benennen",
  "quiz.wizard.step_title_help":
    "Titel kann später aus Uploads kommen; jetzt für Einladungen sichtbar definieren.",
  "quiz.wizard.save_title_continue": "Titel speichern und weiter",
  "quiz.wizard.step_training_heading": "Schulungsmaterial",
  "quiz.wizard.step_training_body":
    "Laden Sie bis zu drei .txt-Dateien (Klartext, UTF-8), .pdf-Dateien oder .xlsx-Dateien. Warten Sie bis alle Dateien Bereit zeigen, dann Weiter. Gescannte PDFs ohne eingebetteten Text liefern wenig oder keinen Text.",
  "quiz.wizard.step_generation_heading":
    "Generierungseinstellungen und Fragenpool",
  "quiz.wizard.step_generation_body":
    "Legen Sie fest, wie viele Fragen Teilnehmende sehen und welche Antwortform gilt, generieren Sie dann Entwurfs-MC-Fragen aus bereiten Trainingsdateien. Pflegen Sie den Pool, bis genug aktive Fragen vorliegen, und fahren Sie fort.",
  "quiz.wizard.generation_pipeline_status": "Generierungs-Pipeline: {status}",
  "quiz.wizard.generation_settings_heading":
    "Einstellungen zur Fragenerzeugung",
  "quiz.wizard.generation_settings_hint":
    "Standardwerte reichen meist; nur bei Bedarf anpassen.",
  "quiz.wizard.generation_questions_per_attempt_label": "Fragen pro Quiz",
  "quiz.wizard.generation_pool_count_label": "Groesse des Fragenpools",
  "quiz.wizard.generation_pool_count_hint":
    "Standard: das Doppelte der Anzahl Fragen pro Quiz; jede Person erhaelt eine zufaellige Stichprobe.",
  "quiz.wizard.generation_shape_heading": "Fragenform",
  "quiz.wizard.generation_option_count_label": "Antworten pro Frage",
  "quiz.wizard.generation_min_correct_label":
    "Mindestanzahl richtiger Antworten",
  "quiz.wizard.generation_max_correct_label":
    "Hoechstanzahl richtiger Antworten",
  "quiz.wizard.generation_shape_invalid":
    "Fragenform pruefen: 1 <= Mindestanzahl richtiger Antworten <= Hoechstanzahl <= Antworten pro Frage.",
  "quiz.wizard.generation_single_correct_note":
    "Die automatische Generierung liefert weiterhin genau eine vollstaendig richtige Antwort pro Frage.",
  "quiz.wizard.generation_config_label":
    "Optionale Generierungs-JSON-Objekt-Einstellungen (verschmelzen mit quiz.configuration)",
  "quiz.wizard.generation_config_placeholder": "{}",
  "quiz.wizard.generation_queue_button": "Generierung einreihen",
  "quiz.wizard.generation_busy": "Senden…",
  "quiz.wizard.generation_json_invalid": "Ungültiges JSON-Objekt.",
  "quiz.wizard.generation_failed":
    "Generierung konnte nicht eingereiht werden.",
  "quiz.wizard.generation_material_not_ready":
    "Alle Trainingsdateien müssen Ready sein.",
  "quiz.wizard.generation_locked": "Quiz nach Publish gesperrt.",
  "quiz.wizard.generation_queued":
    "Generierung eingereiht. Pool unten pflegen, dann weiter.",
  "quiz.wizard.generation_completed_failed":
    "Der Server hat den letzten Generierungsversuch als fehlgeschlagen markiert.",
  "quiz.wizard.generation_done_reload":
    "Generierung beendet — der Pool wurde aktualisiert.",
  "quiz.wizard.generation_failed_banner":
    "Die letzte Generierung ist fehlgeschlagen. Extrakte oder JSON prüfen (z.B. QUIZ_BEDROCK_MODEL_ID für Bedrock) und erneut starten.",
  "quiz.wizard.generation_running_notice":
    "Fragen werden aus den READY-Extrakten erzeugt — kurz warten.",
  "quiz.wizard.generation_reset_hint":
    "Nach Lambda-Zeitlimit plus Puffer (oft einige Minuten) koennen Sie zuruecksetzen, wenn weiterhin «running» angezeigt wird. Nicht zuruecksetzen, solange die Generierung aktiv ist.",
  "quiz.wizard.generation_reset_stuck_button":
    "Haengende Generierung zuruecksetzen",
  "quiz.wizard.generation_reset_busy":
    "Generierungsstatus wird zurueckgesetzt…",
  "quiz.wizard.generation_reset_failed": "Zuruecksetzen fehlgeschlagen.",
  "quiz.wizard.generation_reset_too_soon":
    "Die Generierung laeuft auf dem Server moeglicherweise noch. Einige Minuten warten, dann erneut versuchen oder die Seite neu laden.",
  "quiz.wizard.pool_readonly_while_running":
    "Poolbearbeitung pausiert während Generierung läuft.",
  "quiz.wizard.pool_edit": "Bearbeiten",
  "quiz.wizard.pool_save_edit": "Änderungen speichern",
  "quiz.wizard.pool_cancel_edit": "Abbrechen",
  "quiz.wizard.generation_in_progress_blocked":
    "Für dieses Quiz läuft bereits eine Generierung.",
  "quiz.wizard.generation_continue_blocked": "Zuerst Generierung einreihen.",
  "quiz.wizard.generation_continue_blocked_pool":
    "Zu wenige aktive Fragen für questions_per_attempt; bitte im Pool nachlegen.",
  "quiz.wizard.pool_section_title": "Entwurfs-Fragenpool",
  "quiz.wizard.pool_section_help":
    "Jede Frage braucht genau {n, plural, one {# Antwortoption} other {# Antwortoptionen}} (option_count in der Konfiguration, Standard vier).",
  "quiz.wizard.pool_empty":
    "Noch keine Entwurfsfragen. Unten mindestens eine anlegen.",
  "quiz.wizard.pool_stem_placeholder": "Fragetext für Teilnehmende",
  "quiz.wizard.pool_choice_label": "Option {n}",
  "quiz.wizard.pool_correct_label":
    "Richtige Option (Position in der Liste, ab 1 gezählt)",
  "quiz.wizard.pool_correct_multi_hint":
    "Mark every choice that should count as correct (within the minimum and maximum you set in generation settings).",
  "quiz.wizard.pool_choices_aria": "Antwortoptionen",
  "quiz.wizard.pool_correct_option_mark": "Richtig",
  "quiz.wizard.pool_item_meta":
    "{count, plural, one {# Option} other {# Optionen}}; richtige Position {pos}",
  "quiz.wizard.pool_inactive_marker": "(inaktiv)",
  "quiz.wizard.pool_delete": "Entfernen",
  "quiz.wizard.pool_add_aria": "Frage hinzufuegen",
  "quiz.wizard.pool_add_button": "Frage hinzufügen",
  "quiz.wizard.pool_busy": "Pool wird gespeichert…",
  "quiz.wizard.pool_failed": "Pool-Update fehlgeschlagen. Felder prüfen.",
  "quiz.wizard.pool_validation": "Stammtext und alle Optionen ausfüllen.",
  "quiz.wizard.pool_publish_hint":
    "Aktive Fragen: {active}. Mindestens {needed} aktive Fragen laut Konfiguration nötig.",
  "quiz.wizard.publish_pool_too_small":
    "Aktiver Pool kleiner als questions_per_attempt. Schritt 3 öffnen und Fragen ergänzen.",
  "quiz.wizard.step_invite_heading": "Empfänger & Einladungen",
  "quiz.wizard.step_invite_body":
    "Je Zeile eine E-Mail-Adresse; Server dedupliziert auf max. 20 Adressen.",
  "quiz.wizard.recipients_label": "Empfänger-E-Mail",
  "quiz.wizard.recipients_placeholder":
    "person1@organisation.org\nperson2@organisation.org",
  "quiz.wizard.recipients_hint":
    "Leerzeilen raus; keine Duplikate; höchstens 20 Adressen.",
  "quiz.wizard.publish_button": "Veröffentlichen und senden",
  "quiz.wizard.publish_failed":
    "Konnte nicht veröffentlichen; Adressen prüfen und erneut versuchen.",
  "quiz.wizard.publish_conflict":
    "Dieses Quiz wurde schon einmal veröffentlicht.",
  "quiz.wizard.publish_validation":
    "Mindestens eine Adresse wirkt nach Normalisierung ungültig.",
  "quiz.wizard.back_step": "Zurück",
  "quiz.wizard.continue": "Weiter",
  "quiz.wizard.success_title": "Einladungen gespeichert",
  "quiz.wizard.success_lead_publish":
    "Zuordnungen sind gespeichert; Versand folgt SES-Konfiguration.",
  "quiz.wizard.success_lead_repeat":
    "Gespeicherte Einladungen: {count, plural, one {#} other {#}}.",
  "quiz.wizard.mail_notice_ses_optional":
    "SES sendet sobald QUIZ_SES_MAIL_FROM aktiv und SES freigeschaltet ist.",
  "quiz.wizard.mail_notice_skipped":
    "SES fehlt; Mail bleibt vorbereitet bis Betreiber die Umgebung setzen.",
  "quiz.wizard.mail_sent": "Gesendet",
  "quiz.wizard.mail_failed": "Fehlgeschlagen",
  "quiz.wizard.mail_skipped": "Übersprungen (kein SES)",
  "quiz.wizard.col_email": "Empfänger",
  "quiz.wizard.col_delivery": "Mail-Status",
  "quiz.wizard.back_to_my_quizzes": "Zur Liste Meine Quizze",
  "quiz.wizard.view_quiz_detail": "Quiz-Details anzeigen",
  "quiz.wizard.material_docs_heading": "Hochgeladene Dateien",
  "quiz.wizard.material_empty":
    "Noch keine Datei — mindestens eine unten hinzufügen.",
  "quiz.wizard.material_upload_pick": "Datei wählen (.txt, .pdf, .docx, .xlsx)",
  "quiz.wizard.material_choose_file": "Datei wählen",
  "quiz.wizard.material_drop_aria":
    "Schulungsdateien per Drag-and-Drop oder Dateidialog hinzufügen",
  "quiz.wizard.material_drop_hint":
    "Dateien hier ablegen (.txt, .pdf, .docx, .xlsx) oder",
  "quiz.wizard.material_busy": "Wird hochgeladen…",
  "quiz.wizard.material_no_file": "Zuerst eine Datei wählen.",
  "quiz.wizard.material_failed": "Upload fehlgeschlagen. Erneut versuchen.",
  "quiz.wizard.material_put_failed":
    "Direkt-Upload zum Speicher fehlgeschlagen.",
  "quiz.wizard.material_storage_off":
    "Material-Speicher nicht konfiguriert (Betrieb: QUIZ_MATERIAL_BUCKET).",
  "quiz.wizard.material_limit": "Maximale Anzahl Schulungsdateien erreicht.",
  "quiz.wizard.material_next_blocked":
    "Weiter nur wenn alle Dateien Bereit anzeigen.",
  "quiz.wizard.material_delete_aria": "Datei entfernen",
  "quiz.wizard.material_remove_failed":
    "Datei konnte nicht entfernt werden. Erneut versuchen.",
  "quiz.wizard.material_state_AWAITING_BYTES": "Wartet auf Upload",
  "quiz.wizard.material_state_INGESTING": "Verarbeitung",
  "quiz.wizard.material_state_READY": "Bereit",
  "quiz.wizard.material_state_FAILED": "Fehlgeschlagen",
  "quiz.health.heading": "Backend-Status",
  "quiz.health.loading": "Rufe GET /api/v1/health auf...",
  "quiz.health.httpStatus": "HTTP-Status: {status}",
  "quiz.health.responseBody": "Antwortkörper",
  "quiz.health.networkError": "API war nicht erreichbar.",
  "quiz.health.notJson": "Antwort war kein gültiges JSON.",
  "quiz.organizer.sign_in.title": "Anmelden",
  "quiz.organizer.sign_in.lead": "Wählen Sie einen Anbieter.",
  "quiz.organizer.sign_in.google": "Mit Google fortfahren",
  "quiz.organizer.sign_in.github": "Mit GitHub fortfahren",
  "quiz.organizer.sign_in.bootstrap.heading":
    "Operator-Anmeldedaten (Umgebung)",
  "quiz.organizer.sign_in.bootstrap.lead":
    "Für Ausnahmezugang, wenn OAuth nicht verfügbar ist.",
  "quiz.organizer.sign_in.bootstrap.username_label": "Benutzername",
  "quiz.organizer.sign_in.bootstrap.password_label": "Passwort",
  "quiz.organizer.sign_in.bootstrap.submit": "Anmelden",
  "quiz.organizer.sign_in.nav_home": "Startseite",
  "quiz.components.button.sample_label": "Weiter",
  "quiz.components.button.danger_sample": "Entfernen",
  "quiz.components.icon_button.sample_aria": "Weitere Aktionen",
  "quiz.components.icon_button.sample_glyph": "+",
  "quiz.ui_demo.heading": "UI-Komponentenbibliothek",
  "quiz.ui_demo.lead":
    "Statische Übersicht gemeinsamer quiz-frontend-Steuerelemente auf allen Routen.",
  "quiz.ui_demo.subheading_buttons": "Schaltflächen",
  "quiz.ui_demo.caption_enabled": "Primär aktiv",
  "quiz.ui_demo.caption_disabled": "Primär deaktiviert",
  "quiz.ui_demo.caption_app_link": "Textlink",
  "quiz.ui_demo.caption_btn_danger": "Gefahren-Schaltfläche",
  "quiz.ui_demo.caption_btn_ghost": "Ghost-Schaltfläche",
  "quiz.ui_demo.caption_btn_secondary": "Sekundäre Outline-Schaltfläche",
  "quiz.ui_demo.caption_icon_btn": "Symbol-Schaltfläche",
  "quiz.ui_demo.caption_layout_card": "Kartenfläche",
  "quiz.ui_demo.caption_layout_headings": "Überschriftenstufen",
  "quiz.ui_demo.caption_layout_stack": "Vertikaler Stapel",
  "quiz.ui_demo.caption_layout_text": "Fließtext und gedrosselter Text",
  "quiz.ui_demo.sample_app_link_label": "Gesundheitscheck-Seite öffnen",
  "quiz.ui_demo.sample_card_body": "Beispielinhalt innerhalb der Karte.",
  "quiz.ui_demo.sample_heading_h3": "Dritte Überschriftsebene",
  "quiz.ui_demo.sample_heading_h4": "Vierte Überschriftsebene",
  "quiz.ui_demo.sample_text_body": "Primärer Fließtext für Beschreibungen.",
  "quiz.ui_demo.sample_text_muted": "Gedrosselter Hinweistext.",
  "quiz.ui_demo.skip_to_main": "Zum Hauptinhalt springen",
  "quiz.ui_demo.stack_line_one": "Stapelzeile eins",
  "quiz.ui_demo.stack_line_two": "Stapelzeile zwei",
  "quiz.ui_demo.subheading_forms": "Formulare",
  "quiz.ui_demo.subheading_layout": "Layout und Typografie",
  "quiz.ui_demo.caption_field_file": "Datei mit Beschriftung",
  "quiz.ui_demo.caption_field_radio": "Optionsgruppe",
  "quiz.ui_demo.caption_field_select": "Auswahl",
  "quiz.ui_demo.caption_field_text": "Text mit Hinweis",
  "quiz.ui_demo.caption_field_text_invalid": "Text mit Fehler",
  "quiz.ui_demo.caption_field_textarea": "Mehrzeiliges Textfeld",
  "quiz.ui_demo.caption_checkbox": "Kontrollkästchen",
  "quiz.ui_demo.forms_error_required": "Name ist erforderlich.",
  "quiz.ui_demo.forms_file_hint": "Akzeptiert nur .txt für die Demo.",
  "quiz.ui_demo.forms_hint_name": "Wird in Formularen als Anzeigename genutzt.",
  "quiz.ui_demo.forms_label_agree": "Ich stimme den Demo-Bedingungen zu",
  "quiz.ui_demo.forms_label_bio": "Biografie",
  "quiz.ui_demo.forms_label_locale": "Vorschau-Sprache",
  "quiz.ui_demo.forms_label_name": "Anzeigename",
  "quiz.ui_demo.forms_label_upload": "Schulungsdatei",
  "quiz.ui_demo.forms_placeholder_bio": "Kurzer Biografietext",
  "quiz.ui_demo.forms_placeholder_name": "Ada Lovelace",
  "quiz.ui_demo.forms_radio_a": "Option A",
  "quiz.ui_demo.forms_radio_b": "Option B",
  "quiz.ui_demo.forms_radio_legend": "Eine Option wählen",
  "quiz.ui_demo.forms_select_de": "Deutsch",
  "quiz.ui_demo.forms_select_en": "Englisch",
  "quiz.ui_demo.alert_error_body": "Korrigieren Sie die markierten Felder.",
  "quiz.ui_demo.alert_error_title": "Speichern fehlgeschlagen",
  "quiz.ui_demo.alert_info_body": "Hintergrundjobs können eine Minute dauern.",
  "quiz.ui_demo.alert_info_title": "Hinweis",
  "quiz.ui_demo.alert_success_body": "Ihr Entwurf wurde gespeichert.",
  "quiz.ui_demo.alert_success_title": "Gespeichert",
  "quiz.ui_demo.alert_warn_body":
    "Poolgröße liegt nahe am Minimum für Publish.",
  "quiz.ui_demo.alert_warn_title": "Pool prüfen",
  "quiz.ui_demo.caption_alert_error": "Fehler-Hinweis",
  "quiz.ui_demo.caption_alert_info": "Info-Hinweis",
  "quiz.ui_demo.caption_alert_success": "Erfolgs-Hinweis",
  "quiz.ui_demo.caption_alert_warning": "Warn-Hinweis",
  "quiz.ui_demo.caption_badges": "Status-Badges",
  "quiz.ui_demo.caption_empty_demo": "Leerzustand",
  "quiz.ui_demo.caption_loading_row": "Ladezeile",
  "quiz.ui_demo.caption_progress_demo": "Fortschrittszeile",
  "quiz.ui_demo.caption_table_demo": "Einfache Tabelle",
  "quiz.ui_demo.display_badge_neutral": "Entwurf",
  "quiz.ui_demo.display_badge_success": "Bereit",
  "quiz.ui_demo.display_badge_warning": "Warteschlange",
  "quiz.ui_demo.display_empty_body":
    "Legen Sie ein Quiz an, um Entwürfe zu sehen.",
  "quiz.ui_demo.display_empty_title": "Noch keine Quizze",
  "quiz.ui_demo.display_progress_text": "Schritt 2 von 5 (Demo).",
  "quiz.ui_demo.display_table_col_email": "E-Mail",
  "quiz.ui_demo.display_table_col_state": "Status",
  "quiz.ui_demo.display_table_row1_email": "a@example.com",
  "quiz.ui_demo.display_table_row1_state": "SENT",
  "quiz.ui_demo.display_table_row2_email": "b@example.com",
  "quiz.ui_demo.display_table_row2_state": "NOT_SENT",
  "quiz.ui_demo.loading_label": "Quizze werden geladen...",
  "quiz.ui_demo.subheading_display": "Datenanzeige",
  "quiz.ui_demo.subheading_feedback": "Hinweise und Laden",
  "quiz.ui_demo.locale_picker_label": "Oberflächensprache",
  "quiz.ui_demo.caption_disclosure": "Aufklappblock",
  "quiz.ui_demo.caption_mc_option": "Multiple-Choice-Kacheln",
  "quiz.ui_demo.caption_modal": "Modaler Dialog",
  "quiz.ui_demo.caption_pool_row": "Pool-Zeile",
  "quiz.ui_demo.caption_reader": "Schulungsleser",
  "quiz.ui_demo.domain_mc_opt_a": "Antworttext A",
  "quiz.ui_demo.domain_mc_opt_b": "Antworttext B",
  "quiz.ui_demo.domain_pool_meta": "4 Optionen · aktiv",
  "quiz.ui_demo.domain_pool_stem":
    "Was ist der erste Schritt in der Checkliste?",
  "quiz.ui_demo.domain_reader_sample":
    "Schulungstext: Identität prüfen vor Zugriff. Beispielabsatz für Scrollen.",
  "quiz.ui_demo.overlay_disclosure_body":
    "Zusatzrichtlinien optional aufgeklappt.",
  "quiz.ui_demo.overlay_disclosure_summary": "Richtliniendetails",
  "quiz.ui_demo.overlay_modal_body": "Nativer Dialog für Bestätigungen.",
  "quiz.ui_demo.overlay_modal_close": "Schließen",
  "quiz.ui_demo.overlay_modal_open": "Beispiel-Dialog öffnen",
  "quiz.ui_demo.overlay_modal_title": "Beispiel-Dialog",
  "quiz.ui_demo.subheading_domain": "Quiz-spezifische Widgets",
  "quiz.ui_demo.subheading_overlays": "Overlays",
  "quiz.participant.answer_all":
    "Bitte alle Fragen beantworten, bevor Sie senden.",
  "quiz.participant.error_load":
    "Die Einladung ist ungültig oder abgelaufen. Nutzen Sie den Link aus der neuesten E-Mail oder wenden Sie sich an den Veranstalter.",
  "quiz.participant.error_missing_token":
    "Diese Seite benötigt einen vollständigen Einladungslink mit Token.",
  "quiz.participant.error_title": "Link konnte nicht geöffnet werden",
  "quiz.participant.loading": "Aufgabe wird geladen…",
  "quiz.participant.name_back_material": "Zurück zum Schulungsmaterial",
  "quiz.participant.name_continue": "Weiter",
  "quiz.participant.name_heading": "Ihre Angaben",
  "quiz.participant.name_hint":
    "Wird in der Ergebnisübersicht angezeigt, wenn der Veranstalter eine Kennzeichnung vorgesehen hat.",
  "quiz.participant.name_intro":
    "Geben Sie den Namen ein, den der Veranstalter zu diesem Versuch sehen soll.",
  "quiz.participant.name_label": "Ihr Name",
  "quiz.participant.name_placeholder": "z. B. Jordan Smith",
  "quiz.participant.name_required": "Bitte geben Sie Ihren Namen ein.",
  "quiz.participant.nav_back": "Zurück",
  "quiz.participant.nav_next": "Weiter",
  "quiz.participant.abort_attempt": "Versuch abbrechen",
  "quiz.participant.abort_attempt_confirm":
    "Diesen Versuch abbrechen? Deine Antworten werden verworfen. Wenn du den Test schon einmal abgeschlossen hast, siehst du stattdessen dieses Ergebnis.",
  "quiz.participant.abort_attempt_aria":
    "Quizversuch ohne Einreichen der Antworten abbrechen",
  "quiz.participant.progress_label": "Frage {current} von {total}",
  "quiz.participant.question_heading": "Fragen",
  "quiz.participant.resume_attempt": "Quiz fortsetzen",
  "quiz.participant.result_failed": "Nicht bestanden",
  "quiz.participant.result_passed": "Bestanden",
  "quiz.participant.result_ident_quiz_label": "Quiz",
  "quiz.participant.result_ident_participant_label": "Abgeschlossen von",
  "quiz.participant.result_ident_participant_not_set": "Kein Name angegeben",
  "quiz.participant.result_training_heading":
    "Schulungsunterlagen dieser Pr\u00fcfung",
  "quiz.participant.result_transcript_heading": "So haben Sie geantwortet",
  "quiz.participant.transcript_option_aria": "Ihre Antwortoption {n}: {text}",
  "quiz.participant.transcript_question_correct": "Richtig",
  "quiz.participant.transcript_question_wrong": "Falsch",
  "quiz.participant.result_transcript_selection_note":
    "Auswertung pro Frage ist in dieser Ansicht nicht verf\u00fcgbar. Unten sehen Sie nur Ihre gew\u00e4hlten Optionen.",
  "quiz.participant.result_retry": "Erneut versuchen",
  "quiz.participant.score_label": "Ergebnis: {percent}%",
  "quiz.participant.score_label_with_threshold":
    "Ergebnis: {percent}% \u2014 Bestehensnote {passPercent}%",
  "quiz.participant.skip_to_main": "Zum Hauptinhalt springen",
  "quiz.participant.start_attempt": "Quiz starten",
  "quiz.participant.submit_assignment_issued": "Einladung gesendet {datetime}",
  "quiz.participant.submit_answers": "Antworten absenden",
  "quiz.participant.submitting": "Wird gesendet…",
  "quiz.participant.training_intro":
    "\u00d6ffnen Sie jeden Dateilink, um die Schulungsunterlage vor dem Start zu speichern.",
  "quiz.participant.training_resume_intro":
    "Sie haben dieses Quiz bereits gestartet. Bei Bedarf k\xf6nnen Sie das Schulungsmaterial erneut pr\xfcfen und dann dort weitermachen, wo Sie aufgeh\xf6rt haben.",
  "quiz.participant.training_docs_empty":
    "Zu diesem Quiz sind noch keine Schulungsunterlagen angeh\xe4ngt.",
  "quiz.participant.training_doc_download_aria":
    "Schulungsdokument {filename} herunterladen",
  "quiz.participant.training_heading": "Schulungsmaterial",
};
